import { render, staticRenderFns } from "./IPList.vue?vue&type=template&id=6446d0b4&scoped=true&"
import script from "./IPList.vue?vue&type=script&lang=js&"
export * from "./IPList.vue?vue&type=script&lang=js&"
import style0 from "./IPList.vue?vue&type=style&index=0&id=6446d0b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446d0b4",
  null
  
)

export default component.exports